<template>
	<div ref="terminal" class="flow-terminal" :data-scrollbar="showScrollbar" />
</template>
<script>
import { defineComponent } from "vue";
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-console */
import { Terminal } from "xterm";
import { FitAddon } from "xterm-addon-fit";
import { SearchAddon } from "xterm-addon-search";
import { SearchBarAddon } from "xterm-addon-search-bar";
import { WebLinksAddon } from "xterm-addon-web-links";
import "xterm/css/xterm.css";

export default defineComponent({
	name: "Terminal",
	props: {
		/**
		 * logs to show
		 */
		logs: {
			type: String,
			default: null
		},
		/**
		 * true | false
		 */
		showSearch: {
			type: Boolean,
			default: false
		},
		showScrollbar: {
			type: Boolean,
			default: true
		}
	},
	watch: {
		logs: {
			handler() {
				this.init();
			}
		},
		showSearch: {
			handler() {
				this.toggleSearch();
			}
		}
	},
	mounted() {
		this.init();
	},
	beforeDestroy() {
		if (this.themeobserver) {
			this.themeobserver.disconnect();
		}
	},
	methods: {
		//242, 137, 104
		addLineNumbers(logs) {
			return `${`\x1b[38;2;123;147;178m${this.lineNumber++}\x1b[0m `.padEnd(4)} ${logs
				.replace(/\n/g, "\r\n")
				.replace(/\[INFO\]/g, "\x1b[38;2;26;149;255m[INFO]\x1b[0m")
				.replace(/\[WARN\]/g, "\x1b[38;2;254;164;1m[WARN]\x1b[0m")
				.replace(/\[ERROR\]/g, "\x1b[38;2;242;66;66m[ERROR]\x1b[0m")
				.replace(/\[DEBUG\]/g, "\x1b[38;2;211;153;255m[DEBUG]\x1b[0m")
				.replace(
					/\d{4}(?:-|\/)[01]\d(?:-|\/)[0-3]\d.[0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?Z?/g,
					date => {
						return `\x1b[38;2;123;147;178m${date}\x1b[0m`;
					}
				)
				.replace(/".+":/g, key => {
					return `\x1b[38;2;242;137;104m${key}\x1b[0m`;
				})
				.replace(/(\r\n|\n\r|\n|\r)/g, (match, p1, _offset, _string) => {
					return `${p1}${`\x1b[38;2;123;147;178m${this.lineNumber++}\x1b[0m `.padEnd(4)} `;
				})}`;
		},
		init() {
			// Checking if parent container is present
			if (this.$refs.terminal) {
				this.$refs.terminal.innerHTML = "";
			}
			// finding theme element from DOM
			const themeElement = document.querySelector(".flow-layout.theme");
			/**
			 * CSS variables are not working in Canvas , so need to read values through computed style
			 */
			const style = getComputedStyle(themeElement);

			const getTheme = () => {
				/**
				 * Check if light theme applied and return theme object
				 */
				if ([...themeElement.classList].find(c => c === "light-theme")) {
					return {
						background: style.getPropertyValue("--dashboard-background"),
						foreground: style.getPropertyValue("--dashboard-font-dark"),
						selection: style.getPropertyValue("--warning-300"),
						white: "#000",
						brightWhite: "#000",
						brightBlack: "#fff",
						black: "#fff"
					};
				} else {
					/**
					 * Default Dark theme object
					 */
					return {
						background: style.getPropertyValue("--gray-900"),
						foreground: style.getPropertyValue("--dashboard-font-dark"),
						selection: style.getPropertyValue("--warning-300"),
						white: "#fff",
						brightWhite: "#fff",
						brightBlack: "#000",
						black: "#000"
					};
				}
			};

			/**
			 * Create Terminal Instance
			 */
			this.terminal = new Terminal({
				fontSize: 14,
				cursorStyle: "underline",
				scrollback: 9999999,
				theme: getTheme()
			});

			/**
			 * Observe for theme changes
			 */
			if (!this.themeobserver) {
				this.themeobserver = new MutationObserver(async () => {
					this.terminal.setOption("theme", getTheme());
				});

				this.themeobserver.observe(themeElement, {
					attributes: true,
					childList: false,
					subtree: false
				});
			}
			/**
			 * Fit according to container width and height
			 */
			this.fitAddon = new FitAddon();
			/**
			 * Search add-on for searching text inside canvas
			 */
			this.searchAddon = new SearchAddon();
			this.searchAddonBar = new SearchBarAddon({ searchAddon: this.searchAddon });
			this.lineNumber = 1;

			this.terminal.loadAddon(this.fitAddon);
			this.terminal.loadAddon(this.searchAddon);
			this.terminal.loadAddon(this.searchAddonBar);
			this.terminal.loadAddon(new WebLinksAddon());

			this.terminal.open(this.$refs.terminal);

			// adding line numbers
			this.write(this.logs);

			this.searchAddonBar.on(".search-bar__btn.close", "click", () => {
				this.$emit("update:showSearch", false);
			});
			this.toggleSearch();
			this.fitAddon.fit();

			new ResizeObserver(() => {
				try {
					this.fitAddon.fit();
				} catch (e) {
					//@ts-checkconsole.error(e);
				}
			}).observe(this.$refs.terminal);

			/**
			 * fix for font loading issue
			 */
			// this.terminal.onResize(() => {
			// 	this.terminal.setOption("fontFamily", `"Operator Mono SSm A", "Operator Mono SSm B"`);
			// 	this.fitAddon.fit();
			// });
		},
		write(logs) {
			this.terminal.write(this.addLineNumbers(logs));
		},
		toggleSearch() {
			if (this.showSearch) {
				this.searchAddonBar.show();
				document.querySelector(".search-bar__input").placeholder = "Search";
			} else {
				this.searchAddonBar.hidden();
			}
		}
	}
});
</script>
<style lang="scss">
.flow-terminal {
	--terminal-font: var(--body-font); //"Operator Mono SSm A", "Operator Mono SSm B";
	height: 100%;
	flex: 1;
	width: 100%;
	overflow: auto;
	font-family: var(--terminal-font);

	.xterm-search-bar__addon {
		position: absolute;
		max-width: 400px;
		border: 1px solid var(--dashboard-border-light);
		top: 0;
		right: 0px;
		background-color: var(--dashboard-element-light);
		box-shadow: unset;
		width: 100%;
		align-items: center;
		height: 36px;
		border-radius: 18px;
		margin: 4px 4px;
		padding: 0px 16px 0px 12px;
		z-index: 3;

		&:focus-within {
			box-shadow: inset 0 0 0 2px var(--dashboard-primary);
		}
		.search-bar__input {
			flex: 1;
			width: unset;
			outline: none;
			background-color: var(--dashboard-element-light);
			font-family: var(--terminal-font);
			color: var(--dashboard-font);
			&::placeholder {
				color: var(--dashboard-input-placeholder);
				font-family: var(--terminal-font);
			}
		}
		.search-bar__btn {
			background-color: var(--dashboard-font-light);
		}
	}
	&[data-scrollbar] {
		.xterm-viewport {
			&::-webkit-scrollbar-track {
				-webkit-box-shadow: inset 0 0 2px var(--dashboard-element-light);
				background-color: var(--dashboard-element-light);
				cursor: pointer;
			}

			&::-webkit-scrollbar {
				cursor: pointer;
				width: 8px;
				height: 8px;
				background-color: transparent;
				display: unset;
				border-radius: 4px;
			}

			&::-webkit-scrollbar-thumb {
				background-color: var(--dashboard-element);
				border-radius: 4px;
			}
			scrollbar-color: var(--dashboard-scrollbar) transparent;
			scrollbar-width: thin;
		}
	}
}
</style>
